import React from 'react';
import Layout from '../Components/Layout';

function Terms(props) {
    return (
        <Layout>
            <section className='container common-space-both'>
                <div className='common-title'>
                    <h1 className='text-black !font-extrabold'>Terms Of Service</h1>
                    <p className='my-3'>Terms of Service (also known as Terms and Conditions, Terms of Use, or User Agreement) are legal agreements that set out the rules and guidelines governing the use of a particular service, website, or platform. While I cannot provide you with the specific terms of service of a particular website or platform since I don't have access to real-time information, I can provide you with a general overview of what is commonly included in terms of service. Here are some key elements typically found in terms of service:</p>
                    <ul className='list-decimal pl-5 text-black [&>li]:pb-3'>
                        <li>
                            Acceptance of Terms: This section states that by accessing or using the service, the user agrees to be bound by the terms and conditions set forth in the agreement.
                        </li>
                        <li>
                            User Responsibilities: It outlines the user's obligations and responsibilities while using the service, such as complying with applicable laws, respecting intellectual property rights, and not engaging in illegal or harmful activities.
                        </li>
                        <li>
                            Intellectual Property: This section clarifies the ownership and protection of intellectual property rights, including copyrights, trademarks, and patents, related to the service and its content.
                        </li>
                        <li>
                            User Conduct: It establishes the expected behavior and prohibited actions of users, such as not violating the rights of others, not posting offensive content, or not engaging in unauthorized activities.
                        </li>
                        <li>
                            Privacy and Data Protection: The terms of service may include information about how user data is collected, used, and protected. It may reference the privacy policy for more specific details.
                        </li>
                        <li>
                            Limitations of Liability: This section outlines the limitations and disclaimers of liability for the service provider, such as not being responsible for any damages incurred while using the service or any loss of data.
                        </li>
                        <li>
                            Termination: It describes the circumstances under which either the user or the service provider can terminate the agreement or suspend the user's access to the service.
                        </li>
                        <li>
                            Governing Law and Dispute Resolution: The terms of service often specify the jurisdiction that governs the agreement and the methods for resolving disputes, such as arbitration or court proceedings.
                        </li>
                        <li>
                            Modifications to the Terms: It explains how and when the terms of service may be updated or revised and how users will be notified of such changes.
                        </li>
                        <li>
                            It is compulsory to give advertisements every month. Then you will get a commission from the company.
                        </li>
                        <li>
                            It is mandatory to see the daily advertisements from the company.
                        </li>
                        <li>
                            Advertisers will give empty ads for no money or if they give a product, they have to take it.
                        </li>
                    </ul>
                    <p>
                        It's important to note that terms of service agreements can vary significantly depending on the specific service or platform. To review the terms of service for a particular website or platform, you can typically find a link to it in the footer or legal section of the website.
                    </p>
                </div>
            </section>
            
        </Layout>
    );
}

export default Terms;